import { gsap, ScrollTrigger } from "../LibrariesImport";
import { CircleType } from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";


export default class BlockTextCircle {
    static init() {
        this.anims = document.querySelectorAll(".block-text-circle");

        this.anims.forEach((anim) => {
            this.buildCircle(anim);
            this.animateRotation(anim); // Ajout de l'animation de rotation
            this.scrollAnimation(anim);

        });

        GlobalVariables.resizeCallbacks.push(this);
    }

    static buildCircle(anim) {
        const inner = anim.querySelector(".circle-inner");
        new CircleType(inner).radius();
        this.textSize(anim);
    }

    static textSize(anim) {
        const inner = anim.querySelector(".circle-inner");
        const animWidth = inner.offsetWidth;
        const charCount = inner.textContent.length;
        const fontSize = (animWidth / charCount) * 4;

        gsap.set(inner, {
            fontSize: fontSize,
        });
    }

    static animateRotation(anim) {
        const outer = anim.querySelector(".circle-outer");
        gsap.to(outer, {
            rotation: 360,
            duration: 30, // durée en secondes
            repeat: -1, // répétition infinie
            ease: "none", // animation linéaire
        });
    }

    static scrollAnimation(anim) {
        const inner = anim.querySelector(".circle-inner");
        const a1 = anim.querySelector(".circle-center svg.fill");
        const a2 = anim.querySelector(".circle-center svg.gradient");
        const overlay = anim.querySelector(".circle-overlay");

        let prevProgress = 0;

        gsap.set(inner, { rotation: 0 });

        ScrollTrigger.create({
            trigger: anim,
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
            onUpdate: (self) => {
                let delta = (self.progress - prevProgress) * 0.4;
                // Si on scroll vers le haut, on convertit le delta négatif en positif
                if (delta < 0) {
                    delta = Math.abs(delta);
                }
                gsap.set(inner, {
                    rotation: `+=${delta * 360}`
                });

                prevProgress = self.progress;
            }
        });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: inner,
                start: "top 90%",
                end: "center 75%",
                scrub: 1
            }
        });
        tl.addLabel("start");
        tl.to(a1, { translateX: "-50%", translateY: "-50%", scale: 1, rotationX: 0, rotationZ: 0, opacity: 1, ease: "power2.in" }, "start" );
        tl.to(a2, { translateX: "-50%", translateY: "-50%", scale: 1, rotationX: 0, rotationZ: 0, opacity: 0, ease: "power2.in" }, "start" );
        tl.to(a1.querySelector("path"), { fill: "#D2D5FF" }, "start" );

        const tl2 = gsap.timeline({
            scrollTrigger: {
                trigger: inner,
                start: "center 90%",
                end: "center 75%",
                scrub: 1
            }
        });
        tl2.addLabel("start");
        tl2.to(overlay, { opacity: 0.3 }, "start" );
    }

    static resize() {
        this.anims.forEach((anim) => {
            this.textSize(anim);
        });
    }


}